import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CreditCard, Lock, ArrowRight } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

const MemberLogin = () => {
  const [cardNumber, setCardNumber] = useState('');
  const [error, setError] = useState('');
  const { login } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from?.pathname || '/member/dashboard';

  const handleCardNumberChange = (e) => {
    let value = e.target.value.replace(/\s/g, '');
    if (value.length <= 16 && /^\d*$/.test(value)) {
      // Format: XXXX XXXX XXXX XXXX
      const formatted = value.match(/.{1,4}/g)?.join(' ') || value;
      setCardNumber(formatted);
      setError('');
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const result = login(cardNumber);
    
    if (result.success) {
      navigate(from, { replace: true });
    } else {
      setError(result.error);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-secondary)',
      padding: '40px 20px'
    }}>
      <div style={{
        maxWidth: '500px',
        width: '100%',
        background: 'var(--bg-primary)',
        border: '1px solid var(--border-light)',
        padding: '48px',
        textAlign: 'center'
      }}>
        {/* Icon */}
        <div style={{
          width: '80px',
          height: '80px',
          margin: '0 auto 32px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          border: '2px solid var(--border-light)',
          background: 'var(--bg-secondary)'
        }}>
          <CreditCard size={40} color="var(--text-primary)" />
        </div>

        {/* Title */}
        <h1 className="hero-medium" style={{ marginBottom: '16px' }}>
          {language === 'fr' ? 'Espace Membre' : 'Member Area'}
        </h1>
        
        <p className="body-regular" style={{
          color: 'var(--text-secondary)',
          marginBottom: '40px',
          lineHeight: 1.7
        }}>
          {language === 'fr'
            ? 'Accédez à votre espace privé en saisissant votre numéro de carte membre'
            : 'Access your private area by entering your member card number'}
        </p>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '24px', textAlign: 'left' }}>
            <label className="body-regular" style={{
              display: 'block',
              marginBottom: '12px',
              color: 'var(--text-primary)'
            }}>
              {language === 'fr' ? 'Numéro de carte (16 chiffres)' : 'Card Number (16 digits)'}
            </label>
            
            <div style={{ position: 'relative' }}>
              <Lock size={20} style={{
                position: 'absolute',
                left: '16px',
                top: '50%',
                transform: 'translateY(-50%)',
                color: 'var(--text-secondary)'
              }} />
              
              <input
                type="text"
                value={cardNumber}
                onChange={handleCardNumberChange}
                placeholder="XXXX XXXX XXXX XXXX"
                style={{
                  width: '100%',
                  padding: '16px 16px 16px 48px',
                  border: error ? '2px solid #ba3e2b' : '1px solid var(--border-light)',
                  background: 'var(--bg-primary)',
                  color: 'var(--text-primary)',
                  fontSize: '18px',
                  letterSpacing: '2px',
                  fontFamily: 'monospace',
                  outline: 'none',
                  transition: 'border-color 0.2s ease'
                }}
                onFocus={(e) => {
                  if (!error) e.target.style.borderColor = 'var(--text-primary)';
                }}
                onBlur={(e) => {
                  if (!error) e.target.style.borderColor = 'var(--border-light)';
                }}
              />
            </div>

            {error && (
              <p style={{
                marginTop: '8px',
                color: '#ba3e2b',
                fontSize: '14px',
                textAlign: 'left'
              }}>
                {error}
              </p>
            )}
          </div>

          <button
            type="submit"
            className="btn-primary"
            style={{
              width: '100%',
              justifyContent: 'center',
              marginBottom: '24px'
            }}
          >
            {language === 'fr' ? 'Accéder à mon espace' : 'Access my area'}
            <ArrowRight size={16} />
          </button>
        </form>

        {/* Info */}
        <p className="body-small" style={{
          color: 'var(--text-light)',
          lineHeight: 1.6
        }}>
          {language === 'fr'
            ? 'Votre numéro de carte se trouve au dos de votre carte membre Henry & Gaby'
            : 'Your card number is on the back of your Henry & Gaby membership card'}
        </p>
      </div>
    </div>
  );
};

export default MemberLogin;
